import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useEffect } from "react";
import CheckoutPayment from "./CheckoutPaymentScreen/CheckoutPayment";
//import PaymentResultPlayground from "./CheckoutPaymentScreen/components/PaymentResultPlayground";
import CheckoutReview from "./CheckoutReviewScreen/CheckoutReview";
import Groups from "./Groups/Groups";
import Assignments from "./ManagedAssignmentsScreen/ManagedAssignments";
import Instruments from "./ManagedInstrumentsScreen/ManagedInstruments";
import PsichologistManagementPage from "./PsichologistManagement/PsychologistManagementPage";
import Redirect from "./RedirectScreen/Redirect";
import ResellerClientsManagementPage from "./ResellerClientsManagement/ResellerClientsManagementPage";
import Tutorials from "./Tutorials";
import Coupons from "./Coupons/Coupons";
import UserManagementPage from "./UserManagement/UserManagementPage";
import { getUserRolesFromToken, RolesEnum } from "./utils/getUserRolesFromToken";
import { useLocation } from 'react-router-dom';

import { trackPageView } from "./utils/analytics";
//import Explore from "./Explore/Explore";

const RouteTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
    trackPageView(location.pathname);
  }, [location]);
  return null;
};

export default function Router() {
  const roles = getUserRolesFromToken();
  const isAdmin = roles.includes(RolesEnum.ADMIN);
  const isReseller = roles.includes(RolesEnum.RESELLER);

  return (
    <BrowserRouter>
      <RouteTracker />

      <Routes>
        <Route path="/auth" element={<Redirect />} />
        <Route path="/" element={<Instruments />} />
        <Route path="/instruments" element={<Instruments />} />
        <Route
          path="/users"
          element={
            (!isReseller || (isReseller && isAdmin)) ? <UserManagementPage /> : <Navigate to="/auth" />
          }
        />
        <Route
          path="/psichologists"
          element={
            isAdmin ? <PsichologistManagementPage /> : <Navigate to="/auth" />
          }
        />
        <Route
          path="/reseller/management"
          element={
            isReseller ? <ResellerClientsManagementPage /> : <Navigate to="/auth" />
          }
        />
        <Route
          path="/assignments"
          element={
            (!isReseller || (isReseller && isAdmin)) ? <Assignments /> : <Navigate to="/auth" />
          }
        />
        <Route
          path="/groups"
          element={
            (!isReseller || (isReseller && isAdmin)) ? <Groups /> : <Navigate to="/auth" />}
        />
        <Route 
          path="/coupons" 
          element={isAdmin ? <Coupons /> : <Navigate to="/auth" />} 
        />
        <Route path="/tutorials" element={<Tutorials />} />
        <Route path="/checkout/review" element={<CheckoutReview />} />
        <Route path="/checkout/payment" element={<CheckoutPayment />} />
        {/* <Route path="/checkout/payment/playground" element={<PaymentResultPlayground />} /> */}
      </Routes>
    </BrowserRouter>
  );
}
